import { render, staticRenderFns } from "./introducePage.vue?vue&type=template&id=6b6e4c91&scoped=true"
import script from "./introducePage.vue?vue&type=script&lang=js"
export * from "./introducePage.vue?vue&type=script&lang=js"
import style0 from "./introducePage.vue?vue&type=style&index=0&id=6b6e4c91&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6e4c91",
  null
  
)

export default component.exports